// components/portal/SourceEmojiPicker.tsx
//
// The emoji picker for a Source page glyph.
//
// Same library and the same dark theme Doctrine already uses (emoji-picker-react, loaded
// client-side only because it touches window on import). Kept in its own file rather than inlined
// so the dynamic import is not re-declared inside a component that re-renders on every campaign
// tick - a dynamic() call in a render body creates a new component type each pass, which remounts
// the picker and loses its scroll position mid-scroll.
'use client';

import React from 'react';
import { EmojiPickerLazy } from '@/components/ui/EmojiPickerLazy';


export const SourceEmojiPicker = ({
  onPick,
  hasEmoji,
  lang,
}: {
  onPick: (emoji: string | null) => void;
  hasEmoji: boolean;
  lang: string;
}) => (
  <span className="block overflow-hidden rounded-[10px] border border-[#2A2A2A] bg-[#222222] shadow-[0_10px_30px_rgba(0,0,0,0.55)]">
    {hasEmoji ? (
      <button
        type="button"
        onClick={() => onPick(null)}
        className="block w-full border-b border-[#2A2A2A] px-3 py-2 text-left text-[11px] text-white/50 hover:bg-white/[0.06] hover:text-white/80"
      >
        {lang === 'fr' ? 'Retirer l’emoji' : 'Remove emoji'}
      </button>
    ) : null}
    <EmojiPickerLazy
      theme="dark"
      width={320}
      height={380}
      lazyLoadEmojis
      previewConfig={{ showPreview: false }}
      onEmojiClick={(d) => onPick(d.emoji)}
    />
  </span>
);
